module.exports = __webpack_public_path__ + "static/media/welcome_page_full.8f51d7e8.png";